import { isTokenExpired } from '@sit/client-shared';
import { useToken } from './auth-store';

export function useIsAuthenticated() {
  // Grace period for token expiration in milliseconds
  const requestGracePeriod = 1000;

  const storybookAuthByPass = import.meta.env.MODE === 'development' && import.meta.env.STORYBOOK === 'true';
  const token = useToken();
  return storybookAuthByPass || (token != null && !isTokenExpired(token, requestGracePeriod));
}
